// @Version: 1.0.0
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PARAMETER } from './special-list.model';
import { ILinkList } from 'src/app/shared/pipes/link-list/link-list.model';


//TO-CHANGE 
// Muss für jedes Projekt welches eine spezielle Navigation besitzt angepasst werden
@Component({
   selector: 'app-nav-special-list',
   templateUrl: './special-list.component.html',
   standalone: false
})
export class NavListSpecialComponent {

   @Input() list: ILinkList[] = [];

   @Output() public sidenavClose = new EventEmitter();
   
   constructor (public router: Router) {
      
   }
   
   public onNavListClick (url: string, name: string, target?: string,): void {
      target && target == PARAMETER.BLANK ? window.open(url, target) : this.router.navigate([url]);
      
      this.sidenavClose.emit();
   }
}
